import React from "react";

export default function DiscountTag(props) {
  return (
    <div style={{ display: 'inline-block' }}>
      {props.children.discount < 1 && (
        <div style={{ display: "flex", alignItems: "baseline" }}>
          <div style={{ fontSize: "0.26rem", paddingRight: 1, fontWeight: 600,color:'#FF3F44' }}>{props.children.discount * 10}</div>
          <div style={{ fontSize: "0.24rem", paddingRight: 5, fontWeight: 500, color:'#FF3F44', position: 'relative', top: '-0.5px' }}>折</div>
        </div>
      )}
    </div>
  );
}
